import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';
import { ConfigurationApiService } from 'src/app/services/configuration-api.service';
import { OktaService } from 'src/app/services/okta.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  standalone: false
})
export class AccountComponent  implements OnInit {

  selectedOption: boolean = false;
  triggerDeleteConfirmation: boolean = false;
  isDeletingAccount: boolean = false;
  userDetails : any;
  form = this.fb.group({
    firstName: ["", Validators.required],
    lastName: ["", Validators.required],
    email: ['', [Validators.required, Validators.email]],
    country:  ["", Validators.required],
    company: [""]
  });
  countries: any;
  constructor(private fb: FormBuilder, private modalController: ModalController,
    private cdr: ChangeDetectorRef, private dataService: DataService,
    private oktaService: OktaService,
    private configurationApiService: ConfigurationApiService,
    private toastService: ToastService,
    private translateService: TranslateService) { 
      this.dataService.getCountries().subscribe(countries => {
        this.countries = countries;
      });
  }

  async ngOnInit() {
    this.userDetails = await this.oktaService.userInfo();
    
    this.form.statusChanges.subscribe(status => {
      this.selectedOption = status === 'VALID';
    });
    
     
      if(this.userDetails) {
        this.form.get('firstName')?.setValue(this.userDetails?.name.split(" ")[0]);
        this.form.get('lastName')?.setValue(this.userDetails?.name.split(" ")[1]);
        this.form.get('email')?.setValue(this.userDetails?.email);
        //this.form.get('country')?.setValue(this.userDetails?.country);
        this.form.get('company')?.setValue(this.userDetails?.company);

        
      }
      this.form.get('country')?.disable();
      console.log(this.form)
  }

  ionViewDidEnter() {
    if(this.userDetails?.country) {
          console.log(this.userDetails?.country , " present")
          if(this.countries) {
            console.log(this.countries , " present")
            this.countries.forEach((country:any) => {
              if(country.code == this.userDetails?.country) {
                console.log("matched")
                this.form.get('country')?.setValue(country);
              }
            })
          }
        }
  }

  closeLogin() {
    if(!this.triggerDeleteConfirmation)
      this.modalController.dismiss(null, 'cancel');
    else this.triggerDeleteConfirmation = false;
  }

  validate(){

  }

  triggerConfirmDelete(){
    this.triggerDeleteConfirmation = !this.triggerDeleteConfirmation;
  }

  async confirmDelete(){
    if (this.isDeletingAccount) {
      return;
    }

    this.isDeletingAccount = true;
    try {
      await this.configurationApiService.deleteMyAccount();
      await this.toastService.show(
        this.translateService.instant('DELETE_ACCOUNT_SUCCESS'),
        3000,
        'middle',
        'success'
      );
      await this.oktaService.logout();
      await this.modalController.dismiss({ deletedAccount: true }, 'confirm');
    } catch (error: any) {
      console.error('Delete account failed', error);
      await this.toastService.show(
        error?.message || this.translateService.instant('DELETE_ACCOUNT_ERROR'),
        3000,
        'middle',
        'danger'
      );
      this.triggerDeleteConfirmation = false;
    } finally {
      this.isDeletingAccount = false;
    }
  }
  editUserDetails(){

  }

}
